import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Outlet, useLocation } from "react-router-dom";

const SiteLayout = () => {
    
    const location = useLocation();
    const { i18n } = useTranslation(); // Access i18n instance

    useEffect(() => {
        if (location.pathname.includes("/jp")) {
            console.log(`switched to ja from sitelayout`);
            i18n.changeLanguage("ja");
        } else {
            if (window.location.pathname === "/home" || window.location.pathname === "/home/") {
                console.log(`switched to en-US from sitelayout`);
                i18n.changeLanguage("en-US");
            }
        }
    }, [location.pathname]);

    useEffect(() => {
        document.getElementsByTagName("html")[0].setAttribute("lang", i18n.language);
    }, [i18n.language]);

    return (
        <>
            <Outlet />
        </>
    );
}

export default SiteLayout;